import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal, { Actions } from 'components/shared/StandardModal';
import { BodySmall, BodySmallBold } from 'styles/typography';

type Props = {
  flagTitle: string;
  // What the flag is on for besides everyone. Disabling for everyone deletes it.
  removing?: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function DisableFlagModal({ flagTitle, removing, loading, onConfirm, onCancel }: Props) {
  return (
    <StandardModal title='Disable Feature Flag' onCancel={onCancel}>
      <Content>
        <BodySmallBold>Disable {flagTitle} for everyone?</BodySmallBold>
        <BodySmall>This turns the feature off for all users.</BodySmall>
        {removing && (
          <BodySmall>
            It also removes {removing} it&apos;s turned on for. To give specific people access again, you&apos;ll need
            to add them back.
          </BodySmall>
        )}
        <Actions>
          <Button variant='ghost' onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onConfirm} disabled={loading} variant='danger'>
            {loading ? 'Disabling...' : 'Disable for Everyone'}
          </Button>
        </Actions>
      </Content>
    </StandardModal>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
